import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { AngularGridInstance, Formatters, GridOdataService, GridOption, FieldType } from 'angular-slickgrid';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from '../message.service';
import { RestApiService } from '../rest-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketService } from '../socket.service';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
const defaultPageSize = 50;

@Component({
    selector: 'app-bulkassignment',
    templateUrl: './bulkassignment.component.html',
    styleUrls: ['./bulkassignment.component.css']
})
export class BulkassignmentComponent implements OnInit, OnDestroy {

    isDisable = false;
    displayCit: boolean;
    displayCr: boolean;
    displayPr: boolean;
    clientName: string;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    respObject: any;
    tilesData = [];
    isLabel0: boolean;
    isLabel1: boolean;
    isLabel2: boolean;
    islead: boolean;
    cat1: any;
    cat2: any;
    private userAuth: Subscription;
    private ticketTypeSubscription: Subscription;
    ticketTypeLoaded = false;
    notifier: NotifierService;
    modal: any;
    radius: number;
    checkingdata: string;
    clientId: number;
    categories = [];
    categorySelected: number;
    errorMessage: string;
    isError = false;
    users = [];
    userSelected: number;
    isLoading: boolean;
    ticketTypeSelected: number;
    ticketTypeId: number;
    ticketId: string;
    ticket_type: string;
    statusSelected: number;
    supportGroupSelected: number;
    priorities = [];
    prioritySelected: number;
    raised: string;
    raisedTypeSelected: number;
    minDate: any;
    maxDate: any;
    ticketTypes = [];
    attachment = [];
    cat = [];
    dynamicFields: any;
    priorityType: number;
    priority: string;
    fromDate: string;
    toDate: string;
    startDate: string;
    endDate: string;
    lead: string;
    selectedTitles = [];
    selectedTitles2: any[];
    selectedTitles4 = [];
    gridOptions: GridOption;
    gridOptions2: GridOption;
    searchPageSizeBulk: number;
    gridObj2: any;
    angularGrid2: AngularGridInstance;
    totalItems: number;
    ticketColumn = [];
    angularGrid: AngularGridInstance;
    columnDefinitions = [];
    dataset: any[];
    show: boolean;
    selected: number;
    ticketCreated = false;
    defaultStatus = false;
    defaultUser = false;
    defaultNextUser = false;
    name: string;
    desc: string;
    brief: string;
    rDate: string;
    dDate: string;
    comment: string;
    percent: number;
    solution: string;
    types = [];
    assignedUser: any;
    assignedGroup: any;
    currentUser: string;
    currentGroup: string;
    groups = [];
    status = [];
    assignee_copy: string;
    private tId: any;
    lastCatId: number;
    lastParentId: number;
    statusName: string;
    respTime: string;
    comments = [];
    assignedToMe = false;
    closedticket = false;
    endIndicator = true;
    slaViolated = false;
    logs = [];
    count: number;
    solutions = [];
    private modalReference: NgbModalRef;
    createdByMe = false;
    attachments = [];
    uploadButtonName = 'Upload File';
    fileUploadUrl: string;
    menus = [];
    ticketTab = true;
    commentsTab = true;
    solTab = true;
    attachTab = true;
    logTab = true;
    tabs: any;
    solLoaded: boolean;
    comLoaded: boolean;
    resoTime: string;
    hideAttachment: boolean;
    attachMsg: string;
    isAddIncident: boolean;
    isViewIncident: boolean;
    canAddSolution: boolean;
    canAddComment: boolean;
    showGrid1 = false;
    showGridForViewIncident = false;
    showGridForAddIncident = false;
    showGrid = false;
    step: string;
    assignGroupLength: number;
    isApprovedTicket: boolean;
    isApproved: string;
    worker: any;
    actions = [];
    statusSeq: number;
    escalatedTicket = false;
    seq: number;
    isAsset: boolean;
    assetDisplayed: boolean;
    slaString: any;
    outerColor: any;
    innerColor: any;
    isRInfo: boolean;
    loginName: string;
    email: string;
    mobile: string;
    username: string;
    LIMIT = 7;
    start = 0;
    diplaySLAMeter: boolean;
    private baseCategories = [];
    statusDisabled: boolean;
    replyHideAttachment: boolean;
    solProvided = false;
    displayNewComment: boolean;
    displayNewAttachment: boolean;
    displayNewSolutions: boolean;
    escLevel: string;
    public activateUserReplay: boolean;
    isFollowUp: boolean;
    replyAttachment = [];
    isSelfAssigned: boolean;
    claimNo: string;
    displayClaimNo: boolean;
    isLowestLevel: boolean;
    respPercent: number;
    slaViolatedResp = false;
    slaStringResp: string;
    outerColorResp: any;
    innerColorResp: any;
    lastCommentUser: string;
    private commentSubscribe: Subscription;
    lastComment: string;
    public followUpSelected: number;
    public followUps = [];
    lastSol: string;
    wGroups = [];
    allTicketTypes = [];
    assignee = [];
    assigneeSelected: number;
    ticketStatusSelected: number;
    ticket_id: string;
    ticketIdSearchLoaded: boolean;
    hasFollowupUser: boolean;
    followupUser: string;
    catFilterVal = 0;
    userFilterVal = 0;
    statusComment: string;
    private INCIDENT_TYPE_SEQ = 1;
    usersReply: string;
    psInfo = [];
    viewIncidentData = [];
    addIncidentData = [];
    allStatus = [];
    categoryLoaded = false;
    inciCategories = [];
    filterSearchLoaded: boolean;
    searchTid: string;
    searchCat = [];
    inciId: number;
    columnData = [];
    gridObj: any;
    ticketCount: number;
    private closeModalSubscribe: Subscription;
    private attachmentSubscribe: Subscription;
    addIncidentStatus: number;
    folderLoaded = false;
    displayed = true;
    folderDisplayed = true;
    masterNameObj = [];
    masterNameSelected: number;
    masterDataNameSelected: number;
    data = [];
    data2 = [];
    totalData: number;
    @ViewChild('groupSelect') private groupSelect;
    @ViewChild('statusChange') private statusChange;
    @ViewChild('content') content;
    subRadioDisplay: boolean;
    userGroupSelected = 0;
    typeChecked: string;
    typeSeq: any;
    private aGrpLvl: number;
    dataLoaded: boolean;
    isChangeStatus: boolean;
    isUserReplied: boolean;
    subTypeId: any;
    categoryFilter: string;
    private userName: string;
    private priorityId: any;
    isSearch: boolean;
    private storage: any;
    nextOffset: number;
    pageSize: number;
    top: number;
    checkclientid: number;
    skip: number;
    query: any;
    service: any;
    pageSizeObj: any[];
    pageNo: number;
    totalPage: number;
    pageSizeSelected: number;
    paginationObj: any;
    offset: number;
    previousOffset: number;
    page_no: number;
    isCategory: boolean;
    private disabledCount: number;
    viewSeq: number;
    isManagement: boolean;
    searchUser: FormControl = new FormControl();
    userDtl = [];
    userId: any;
    isExport: boolean;
    tikt_Id: FormControl = new FormControl();
    exportdata: any;
    ticketColumnDefinitions = [];
    columnData2 = [];
    Tickets = [];
    constructor(private messageService: MessageService, private _rest: RestApiService,
        private actRoute: ActivatedRoute, private route: Router, notifier: NotifierService,
        private modalService: NgbModal, private socketService: SocketService, private dialog: MatDialog
    ) {
        this.notifier = notifier;
    }
    angularGridReady(angularGrid: AngularGridInstance) {
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    angularGridReady2(angularGrid: AngularGridInstance) {
        this.angularGrid2 = angularGrid;
        this.gridObj2 = angularGrid && angularGrid.slickGrid || {};
        this.columnData2 = this.gridObj2.getColumns();
    }
    ngOnInit() {

        this.displayCit = false;
        this.displayCr = false;
        this.displayPr = false;
        this.isCategory = false;
        this.nextOffset = 0;
        this.searchPageSizeBulk = 0;
        this.totalItems = 0;
        this.previousOffset = 0;
        this.page_no = 0;
        this.pageSizeObj = this.messageService.searchPaginationBulk;
        this.pageSizeSelected = this.messageService.searchPageSelected;
        this.pageSize = this.messageService.searchPageSizeBulk;
        this.pageNo = 0;
        this.paginationObj = { 'offset': this.nextOffset, 'paginationType': '' };
        this.totalPage = 0;
        this.skip = 0;
        this.totalData = 0;
        this.isSearch = true;
        this.categoryFilter = '';
        this.toDate = '';
        this.checkclientid = this.messageService.clientId;
        this.fromDate = '';
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.ticketIdSearchLoaded = true;
        const now = new Date();
        const nowDate = new Date();
        const nowMonth = nowDate.getMonth();
        const nowDay = nowDate.getDate();
        const nowYear = nowDate.getFullYear();
        this.maxDate = new Date(nowYear, nowMonth, nowDay);
        // this.toDate = this.formatDate(this.maxDate);
        this.endDate = this.messageService.ticketConverter(this.maxDate, 1);
        const previousDate = new Date(now.setDate(now.getDate() - 1));
        const previousMonth = previousDate.getMonth();
        const previousDay = previousDate.getDate();
        const previousYear = previousDate.getFullYear();
        this.minDate = new Date(previousYear, previousMonth, previousDay);
        // this.fromDate = this.formatDate(this.minDate);
        this.startDate = this.messageService.ticketConverter(this.minDate, 1);
        // console.log(this.fromDate + '==========' + this.toDate);

        this.ticket_id = '';
        this.isRInfo = false;
        this.isLoading = false;
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.islead = false;
        this.statusSelected = 0;
        this.addIncidentStatus = 0;
        this.prioritySelected = 0;
        this.userSelected = 0;
        this.ticketStatusSelected = 0;
        this.raised = '';
        this.raisedTypeSelected = 0;
        this.assigneeSelected = 0;
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.userGroups = this.messageService.groupId;
            this.userName = this.messageService.loginName;
            if (this.messageService.getSupportGroup() === null) {
                this.userGroupId = this.userGroups[0].groupId;
                this.groupName = this.userGroups[0].grpName;
                this.grpLevel = this.userGroups[0].level;

            } else {
                const group = this.messageService.getSupportGroup();
                // // console.log(group, typeof group);
                this.userGroupId = group.groupId;
                this.groupName = group.grpName;
                this.grpLevel = group.level;
            }
            this.userGroupSelected = this.userGroupId;
            this.onPageLoad();





        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.clientId = auth[0].clientId;
                this.userGroups = auth[0].groupId;
                this.userName = auth[0].login_name;
                if (this.messageService.getSupportGroup() === null) {
                    this.userGroupId = this.userGroups[0].groupId;
                    this.groupName = this.userGroups[0].grpName;
                    this.grpLevel = this.userGroups[0].level;

                } else {
                    const group = this.messageService.getSupportGroup();
                    // // console.log(group, typeof group);
                    this.userGroupId = group.groupId;
                    this.groupName = group.grpName;
                    this.grpLevel = group.level;
                }
                this.userGroupSelected = this.userGroupId;
                this.onPageLoad();
            });
        }
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.service = new GridOdataService();
        this.gridOptions2 = {
            enableAutoResize: false,
            // autoResize: {
            //     containerId: 'demo-container',
            //     sidePadding: 15
            // },
            rowSelectionOptions: {
                selectActiveRow: false
            },
            checkboxSelector: {
                // you can toggle these 2 properties to show the "select all" checkbox in different location
                // hideInFilterHeaderRow: false,
                // hideInColumnTitleRow: true
            },
            enableCellNavigation: true,
            enableFiltering: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            // enableTranslate: true,
            // i18n: this.translate,
            pagination: {
                // pageSizes: [10, 15, 20, 25, 30, 40, 50, 75, 100],
                pageSizes: [50, 100, 200, 300, 400, 500, 600, 750, 1000],
                pageSize: defaultPageSize,
                totalItems: 0
            },
            presets: {
                // you can also type operator as string, e.g.: operator: 'EQ'
                // filters: [
                //   { columnId: 'gender', searchTerms: ['male'], operator: OperatorType.equal },
                // ],
                // sorters: [
                //   // direction can be written as 'asc' (uppercase or lowercase) and/or use the SortDirection type
                //   { columnId: 'name', direction: 'asc' }
                // ],
                pagination: { pageNumber: 1, pageSize: defaultPageSize }
            },
            // backendServiceApi: {
            //     // service: new GridOdataService(),
            //     // preProcess: () => this.displaySpinner(true),
            //     process: (query) => this.setParameter(query)
            //     // postProcess: (response) => {
            //     //     // this.statistics = response.statistics;
            //     //     // this.displaySpinner(false);
            //     //     this.displayTicket(response);
            //     // }
            // }
        };










    }
    setParameter(query) {
        return new Promise((resolve, reject) => {
            this.query = query;
            if (this.fromDate !== '' || this.toDate !== '') {
                // this.advanceSearch(this.query, 0);
            }
            // }
            // }
            resolve(this.query);
        });
    }
    getUserDetails() {
        for (let i = 0; i < this.userDtl.length; i++) {
            if (this.userDtl[i].login_name === this.raised) {
                this.userId = this.userDtl[i].id;
                // this.userName = this.userDtl[i].name;
            }
        }
    }
    exportToExcel() {
        let ticketId;
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        if (tdate !== '') {
            this.toDate = tdate;
        } else {
            this.toDate = this.endDate;
        }
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        if (fdate !== '') {
            this.fromDate = fdate;
        } else {
            this.fromDate = this.startDate;
        }
        const date1 = new Date(this.fromDate).valueOf();
        const date2 = new Date(this.toDate).valueOf();
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        let isError = false;
        // let cats;
        // console.log('this.cat.length====' + JSON.stringify(this.cat));
        if (this.cat.length > 0) {
            this.categoryFilter = '';
        }

        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                // console.log('this.cat===' + JSON.stringify(this.cat[i]));
                this.categoryFilter += this.cat[i].pid + '#' + this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    this.categoryFilter += ',';
                }
            } else {
                isError = true;
                break;
            }
        }

        const lastChar = this.categoryFilter.substr(-1);
        if (lastChar === ',') {
            this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
        }


        if (this.categoryFilter === '') {
            this.categoryFilter = '0';
        }

        if (this.islead) {
            this.lead = 'Y';
        } else {
            this.lead = 'N';
        }


        if (this.ticket_id === '') {
            ticketId = 0;
        } else {
            ticketId = this.ticket_id;
        }

        if (this.raised !== '') {
            this.raisedTypeSelected = 1;
        } else {
            this.raisedTypeSelected = 0;
        }
        this.dataset = [];
        const data = {
            'ticketTypeId': this.ticketTypeId,
            'clientId': this.clientId,
            'supportgrp_id': this.userGroupSelected,
            'ticketStatusId': this.ticketStatusSelected,
            'ticket_id': ticketId,
            'busi_priority_id': this.prioritySelected,
            'created_frdate': this.fromDate,
            'created_todate': this.toDate,
            'catFilterLt': this.categoryFilter,
            'isTeamLead': this.lead,
            'raisedType': this.raisedTypeSelected,
            'raisedValue': this.raised,
            'assign_id': this.assigneeSelected,
            'grpLevel': 2,
            'isDashboardSearch': 1,
            'ticketTypeSeqNo': this.seq,
            'isManagement': this.isManagement
        };
        // console.log('---------------- data 1' + JSON.stringify(data));
        if (ticketId.length < 6) {
            this.notifier.notify('error', 'Please enter last 4 digits of ticket id');
        } else if (Number(diffDays) > 31) {
            this.notifier.notify('error', this.messageService.REPORT_TIME);
        } else {
            this.ticketIdSearchLoaded = false;


            console.log('this.grpLevel 2=' + this.grpLevel);

            // this._rest.bulksearchsscDataForExport(data).subscribe((res) => {
            //     console.log('this.grpLevel 3=' + this.grpLevel );
            //     console.log('@@@this.data ===' + JSON.stringify(this.data));
            //     this.respObject = res;
            //     console.log('@@@this.respObject===' + JSON.stringify(this.respObject));
            //     if (this.respObject.success) {
            //         this.ticketIdSearchLoaded = true;
            //         this.exportdata = this.respObject.details;
            //         const exportArr = [];
            //         for (let i = 0; i < this.exportdata.length; i++) {
            //             const category = this.respObject.details[i].category;
            //             const cat = category.split(',');
            //             for (let j = 0; j < cat.length; j++) {
            //                 const cat1 = cat[j].split('->');
            //                 // console.log('@@@category===' + JSON.stringify(cat1));
            //                 this.exportdata[i][cat1[0]] = cat1[1];
            //             }
            //             if (this.exportdata[i].ticketCloseDate === undefined || this.exportdata[i].ticketCloseDate === '' ||
            //                 this.exportdata[i].ticketCloseDate === null) {
            //                 this.exportdata[i].ticketCloseDate = '';
            //             } else {
            //                 this.exportdata[i].ticketCloseDate =
            //                     this.messageService.datePipeFunc(this.exportdata[i].ticketCloseDate);
            //             }
            //             exportArr.push({
            //                 'Ticket Id': this.exportdata[i].ticket_id,
            //                 'Created By': this.exportdata[i].createdBy,
            //                 'Created Date Time': this.messageService.datePipeFunc(this.exportdata[i].createdSince),
            //                 'status': this.exportdata[i].status,
            //                 'RequesterInfo': this.exportdata[i].reqInfo,
            //                 'Assignee': this.exportdata[i].assignee,
            //                 'Group': this.exportdata[i].LEVELSHORTDESC,
            //                 'Due Date': this.messageService.datePipeFunc(this.exportdata[i].dDate),
            //                 // 'Closure Date': this.exportdata[i].ticketCloseDate,
            //                 'Escalation Level': this.exportdata[i].escalated_to_grp_nm,
            //                 'Entity': this.exportdata[i].entity_code,
            //                 'IC': this.exportdata[i].ic,
            //                 'SBU': this.exportdata[i].sbu,
            //                 'Function': this.exportdata[i].Function,
            //                 'Module': this.exportdata[i].module,
            //                 'Location': this.exportdata[i].location,
            //                 'Ticket Title': this.exportdata[i].tName,
            //                 'Priority': this.exportdata[i].priority
            //             });
            //             if (this.isLabel1 === true) {
            //                 delete exportArr[i]['Priority'];
            //             }
            //         }
            //         // console.log('---------------- data 2' + JSON.stringify(exportArr));
            //         this.messageService.exportAsExcelFile(exportArr);
            //     } else {
            //         this.notifier.notify('error', this.respObject.errorMessage);
            //         // console.log('im here========>');


            //     }
            // });













        }
    }

    Parent_ticket_id: string

    onPageLoad() {

        this.isDisable = false;
        this._rest.bulkAssignmentTicketUpdate(this.clientId).subscribe(
            (res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    // this.checkingdata = this.respObject.details;
                    // if (this.checkingdata === 'not_updated') {
                    console.log("Success!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

                    //  this.notifier.notify('success', 'BulkAssignment is Success');
                    this.isDisable = false;
                    // } else {
                    //     console.log("Error! bulkAssignmentTicketUpdate");
                    //     // this.notifier.notify('error', this.respObject.errorMessage);
                    //     this.isDisable = false;
                    // }

                } else {
                    console.log("outside ======================!");
                    this.notifier.notify('error', 'Bulk Assignment already in Progress. Pl. wait to finish it.');
                    this.isDisable = true;
                }
            },
            (error) => {
                console.error("API error:", error);
            }
        );


        this.isLoading = true;
        this.tilesData = [];
        this.isExport = false;
        this.tikt_Id.valueChanges.subscribe(
            ticketIdd => {
                if (ticketIdd.length > 0) {
                    this.isExport = true;
                } else {
                    this.isExport = false;
                }
            })
        this.searchUser.valueChanges.subscribe(
            psOrName => {
                this.isLoading = true;
                if (psOrName.length > 4) {
                    this._rest.searchUserDetails(this.clientId, psOrName).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.userDtl = this.respObject.details;

                        } else {
                            //   this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.isLoading = false;
                }
            });




        // this._rest.getSupportGroupByLevelWise(this.clientId, this.groupId).subscribe((res8) => {
        this._rest.getSupportGroupByLevelWise(this.clientId, this.grpLevel).subscribe((res8) => {
            this.respObject = res8;
            // console.log('for this.clientId =============', JSON.stringify(this.clientId));
            // console.log('for this.groupId =============', JSON.stringify(this.grpLevel));
            // console.log('for support group =============', JSON.stringify(this.respObject.details));
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Support Group' });
                this.userGroups = this.respObject.details;
                this.userGroupSelected = 0;

            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

        this.ticketTypeSubscription = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
            this.respObject = res1;
            this.ticketTypeLoaded = true;
            if (this.respObject.success) {
                this.storage = JSON.parse(sessionStorage.getItem('dd'));
                this.types = this.respObject.details;
                if (this.storage === null) {
                    this.ticketTypeId = this.types[0].id;
                    this.seq = this.types[0].seq;
                    this.setDisplayModal();
                } else {
                    const type = this.storage.type;
                    this.types[0].checked = false;
                    for (let i = 0; i < this.types.length; i++) {
                        // console.log(this.types[i].id, type);
                        if (this.types[i].id === type) {
                            this.ticketTypeId = this.types[i].id;
                            this.types[i].checked = true;
                            this.seq = this.types[i].seq;
                            this.types[i].checked = true;
                            this.viewSeq = this.types[i].view_sequence;
                            this.setDisplayModal();
                            break;
                        }
                    }
                    // console.log('seq---------> : ' + this.seq);
                }

                if (this.seq === 1 && this.viewSeq === 1) {
                    this.ticketTypeSelected = 0;
                } else if (this.seq === 1 && this.viewSeq === 2) {
                    this.ticketTypeSelected = 1;
                } else if (this.seq === 5) {
                    this.ticketTypeSelected = 2;
                } else if (this.seq === 6) {
                    this.ticketTypeSelected = 3;
                } else if (this.seq === 7) {
                    this.ticketTypeSelected = 0;
                }
                // ======================================================
                this.getStatus(this.seq);
                this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketTypeId).subscribe((res2) => {
                    this.respObject = res2;
                    if (this.respObject.success) {
                        this.isError = false;
                        // this.respObject.details.unshift({id: 0, name: 'Select Priorities'});
                        this.priorities = this.respObject.details;
                        this.prioritySelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
                this.getColumnDefintion();
                for (let i = 0; i < this.types.length; i++) {
                    if (this.types[i].seq === this.INCIDENT_TYPE_SEQ) {
                        this.inciId = this.types[i].id;
                        break;
                    }
                }

                this._rest.checkSupportGroupManagerialView(this.userGroupSelected).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.isManagement = this.respObject.details[0].management;
                    } else {
                        // this.notifier.notify('error', this.respObject.errorMessage);
                    }
                });

                this.ticketModal();
                this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
                    this.respObject = res3;
                    if (this.respObject.success) {
                        this.islead = this.respObject.details[0].is_spoc;
                        this.getTicketLoadingDataWithAttr();
                        if (this.grpLevel !== 0 && !this.islead) {
                            this._rest.getUserByGroup(this.clientId, this.userGroupSelected).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.isError = false;
                                    // this.respObject.details.unshift({id: 0, name: 'Select User'});
                                    this.assignee = this.respObject.details;
                                    this.assigneeSelected = 0;
                                } else {
                                    //  this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                //  this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        } else if (this.grpLevel === 3 && this.islead) {
                            this._rest.getAllLevelOneAndLevelTwoUser(this.clientId).subscribe((res5) => {
                                this.respObject = res5;
                                if (this.respObject.success) {
                                    this.isError = false;
                                    // this.respObject.details.unshift({id: 0, name: 'Select User'});
                                    this.assignee = this.respObject.details;
                                    this.assigneeSelected = 0;
                                } else {
                                    //this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                // this.isError = true;
                                // this.errorMessage = this.messageService.SERVER_ERROR;
                            });
                        } else {
                            this.assigneeSelected = Number(this.messageService.getUserId());
                        }
                    } else {

                    }
                });
            }
        });
        if (this.grpLevel === 0) {
            this.isLabel0 = true;
        } else if (this.grpLevel === 1) {
            this.isLabel1 = true;
            this.isLabel0 = false;
        } else if (this.grpLevel >= 2) {
            this.isLabel2 = true;
            this.isLabel0 = false;
        }
    }
    groupId(clientId: number, groupId: any) {
        throw new Error('Method not implemented.');
    }
    onSelectGroup() {
        // // console.log(typeof this.userGroupSelected);
        // if (this.userGroupSelected !== 0) {
        //     this.userGroupId = this.userGroupSelected;
        //     for (let i = 0; i < this.userGroups.length; i++) {
        //         if (this.userGroups[i].groupId === this.userGroupId) {
        //             this.groupName = this.userGroups[i].grpName;
        //             this.grpLevel = this.userGroups[i].level;
        //         }
        //     }
        //     this.messageService.saveSupportGroup({
        //         groupId: this.userGroupId,
        //         grpName: this.groupName,
        //         level: this.grpLevel
        //     });
        //     this.dataset = [];
        //     this.totalData = 0;
        //     this.onPageLoad();
        // }

        this._rest.getUserByGroup(this.clientId, this.userGroupSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                // this.respObject.details.unshift({id: 0, name: 'Select User'});
                this.assignee = this.respObject.details;
                this.assigneeSelected = 0;
                this.dataset = [];
                this.totalData = 0;
                console.log('assigneeSelected ============= > ', this.assigneeSelected);
            } else {
                //  this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            //  this.notifier.notify('error', this.respObject.errorMessage);
        });
    }

    getStatus(sequence) {
        this._rest.getStatusByTicketTypeLt(sequence, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                // this.respObject.details.unshift({id: 0, status: 'Select Ticket Status'});
                this.allStatus = this.respObject.details;
                this.statusSelected = 0;

                // console.log('status ============= > ', this.allStatus);

            } else {
                //this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            //this.notifier.notify('error', JSON.stringify(err));
        });
    }
    getIncidentCategory() {
        const cat = this.messageService.getCategory1();
        this._rest.getTicketCreateLoadingDtlsForSearch(this.messageService.getUserId(), this.inciId, this.clientId,
            cat.cat1, cat.cat2, this.userGroupSelected, this.islead).subscribe((res) => {
                this.respObject = res;
                this.categoryLoaded = true;
                if (this.respObject.success) {
                    this.inciCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    ticketModal() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.dataset = [];
            this.ticketIdSearchLoaded = true;
            this.filterSearchLoaded = true;
            this.getIncidentCategory();
            // this._rest.getStatusByTicketTypeForIncident(1, this.clientId).subscribe((res) => {
            //     this.respObject = res;
            //     if (this.respObject.success) {
            //         this.respObject.details.unshift({ id: 0, status: 'Select Status' });
            //         this.allStatus = this.respObject.details;
            //         this.statusSelected = 0;
            //     }
            // });
            // this.addedTicket = [];
            this.dataset = [];
            // console.log('CONTENT DATA ======================', JSON.stringify(this.dataset));

            this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.ticketTypeId).subscribe((res2) => {
                this.respObject = res2;
                if (this.respObject.success) {
                    const data = this.respObject.details;
                    const data1 = [];
                    this.columnDefinitions = [
                        { id: 'checkbox', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true },
                        // { id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true },
                        { id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 100, sortable: true, filterable: true },
                        {
                            id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 100, sortable: true, filterable: true
                        },
                        {
                            id: 'createdSince', name: 'Created Date Time', field: 'createdSince', minWidth: 100, sortable: true,
                            // type: FieldType.dateIso,
                            filterable: true
                        },
                        {
                            id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 100, filterable: true
                        },
                        {
                            id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
                        },
                        // {
                        //     id: 'priority', name: 'Priority', field: 'priority', minWidth: 100, sortable: true, filterable: true
                        // },
                        {
                            id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 100, sortable: true, filterable: true
                        },
                        {
                            id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
                        },
                        {
                            id: 'dDate',
                            name: 'Due Date',
                            field: 'dDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            // type: FieldType.dateIso
                        },
                        {
                            id: 'updateDate',
                            name: 'Last Update Date',
                            field: 'updateDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                        }

                        // {
                        //     id: 'updateBy', 
                        //     name: 'Last Updated By', 
                        //     field: 'updateBy', 
                        //     minWidth: 100, 
                        //     sortable: true, 
                        //     filterable: true
                        // }
                        // {
                        //     id: 'closureDate',
                        //     name: 'Closure Date',
                        //     field: 'closureDate',
                        //     minWidth: 100,
                        //     sortable: true,
                        //     filterable: true,
                        //     // type: FieldType.dateIso
                        // }
                    ];

                    for (let i = 0; i < data.length; i++) {
                        this.columnDefinitions.push({
                            id: data[i].field,
                            name: data[i].name,
                            field: data[i].field,
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        });
                    }
                    // this.columnDefinitions.push({
                    //     id: 'title',
                    //     name: 'Ticket Title',
                    //     field: 'tName',
                    //     minWidth: 100,
                    //     sortable: true,
                    //     filterable: true
                    // });
                    // for (let j = 0; j < this.columnData2.length; j++) {
                    //     data1.push(this.columnData2[j]);
                    // }
                    for (let j = 0; j < this.columnData2.length; j++) {
                        data1.push(this.columnData2[j]);
                    }

                    for (let k = 0; k < this.columnDefinitions.length; k++) {
                        data1.push(this.columnDefinitions[k]);
                    }

                    // for (let i = 0; i < data.length; i++) {
                    //     data1.push({
                    //         id: data[i].field,
                    //         name: data[i].name,
                    //         field: data[i].field,
                    //         minWidth: 100,
                    //         sortable: true,
                    //         filterable: true
                    //     });
                    // }
                    data1.push({
                        id: 'title',
                        name: 'Ticket Title',
                        field: 'tName',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    });
                    data1.push({
                        id: 'entity',
                        name: 'Entity',
                        field: 'entity_code',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    }, {
                        id: 'ic', name: 'IC', field: 'ic', minWidth: 100, sortable: true, filterable: true
                    }, {
                        id: 'sbu', name: 'SBU', field: 'sbu', minWidth: 100, sortable: true, filterable: true
                    }, {
                        id: 'loction',
                        name: 'LOCATION',
                        field: 'location',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    }
                        // , {
                        //     id: 'band', name: 'Band', field: 'band', minWidth: 100, sortable: true, filterable: true
                        // }
                    );
                    if (this.grpLevel !== 0) {
                        data1.push({
                            id: 'priority',
                            name: 'Priority',
                            field: 'priority',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        });
                    }
                    this.gridObj2.setColumns(data1);
                    const classes = document.getElementsByClassName('search-filter');
                    for (let i = 0; i < classes.length; i++) {
                        classes[i].setAttribute('placeholder', '');
                    }
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', JSON.stringify(err));
            });
            // ======================================end silk grid ==========================================
            // this.masterNameSelected = 0;

            // const params = {clientId: this.clientId};
            // // console.log('$$$$$$$$$$$$$$$$', params);
            // this._rest.getAllIncidentTicketDetails(this.clientId).subscribe((res1) => {
            //   this.displayTicket(res1);
            // }, (err) => {
            //   this.notifier.notify('error', this.respObject.SERVER_ERROR);
            // });

            // this.modalRef = this.modalService.open(contentData, { size: 'lg' });
            // this.modalRef.result.then((result) => {
            // }, (reason) => {

            // });
        }
    }
    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    setDisplayModal() {
        if (this.seq === 5) {
            this.displayCr = true;
            this.displayCit = false;
            this.displayPr = false;
        } else if (this.seq === 6) {
            this.displayPr = true;
            this.displayCr = false;
            this.displayCit = false;
        } else {
            this.displayCit = true;
            this.displayCr = false;
            this.displayCr = false;
        }
    }

    displayTicket(res, offset, paginationType) {
        this.respObject = res;
        if (this.respObject.success) {
            this.gridObj2.getSelectionModel().setSelectedRanges([]);
            for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
                this.respObject.details.dataObj[i].createdSince =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].createdSince);
                this.respObject.details.dataObj[i].dDate =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].dDate);
                this.respObject.details.dataObj[i].updateDate =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].updateDate);
                if (this.respObject.details.dataObj[i].ticketCloseDate === undefined || this.respObject.details.dataObj[i].ticketCloseDate === '' ||
                    this.respObject.details.dataObj[i].ticketCloseDate === null) {
                    this.respObject.details.dataObj[i].ticketCloseDate = '';
                } else {
                    this.respObject.details.dataObj[i].ticketCloseDate =
                        this.messageService.datePipeFunc(this.respObject.details.dataObj[i].ticketCloseDate);
                }
                this.respObject.details.dataObj[i].requestedDate =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].requestedDate);
                const category = this.respObject.details.dataObj[i].category;
                const cat = category.split(',');
                for (let j = 0; j < cat.length; j++) {
                    const cat1 = cat[j].split('->');
                    this.respObject.details.dataObj[i][cat1[0]] = cat1[1];
                }
            }

            if (offset === 0) {
                this.totalData = this.respObject.details.totalData[0].count;
                this.totalPage = this.respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
                // console.log('checking totalPage', this.totalPage);

            }

            if (this.respObject.details.dataObj.length > 0) {
                this.dataset = this.respObject.details.dataObj;
                this.nextOffset = this.respObject.details.nextOffset;
                this.offset = this.respObject.details.nextOffset;
                this.previousOffset = this.respObject.details.previousOffset;
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
                if (this.page_no === 1) {
                    this.previousOffset = 0;
                }
                // console.log('checking page no', this.page_no);
            } else if ((this.respObject.details.dataObj.length === 0) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if ((this.respObject.details.dataObj.length === 0) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
                this.dataset = [];
                this.gridOptions2 = Object.assign({}, this.gridOptions2);

            }
            this.gridOptions2 = Object.assign({}, this.gridOptions2);

        } else {
            //   this.notifier.notify('error', this.respObject.errorMessage);
        }
    }

    resetSearch() {
        window.location.reload();
        this.Parent_ticket_id = '';
        // this.ticketStatusSelected = 0;
        // this.statusSelected = 0;
        // this.userGroupSelected = 0;
        // this.prioritySelected = 0;
        this.raisedTypeSelected = 0;
        // this.ticketTypeSelected = 0;
        this.ticket_id = '';
        this.raised = '';
        this.totalItems = 0;
        // this.dataset = [];
        this.totalData = 0;
        // this.toDate = '';
        // this.fromDate = '';
        this.categoryFilter = '';
        this.page_no = 0;

        this.totalPage = 0;
        this.getTicketLoadingDataWithAttr();
        if (this.grpLevel === 1 && this.islead) {
            this.assigneeSelected = 0;
        } else {
            this.assigneeSelected = Number(this.messageService.getUserId());

        }

        // console.log(",,,,,,,,,,,,,," + [Number(this.messageService.getUserId())])
    }
    getTicketLoadingDataWithAttr() {
        this._rest.getTicketCreateLoadingDtlsWithGroup(this.messageService.getUserId(), this.ticketTypeId,
            this.clientId, this.userGroupSelected).subscribe((res) => {
                this.respObject = res;
                this.categoryLoaded = true;
                if (this.respObject.success) {
                    // console.log('=================>' + JSON.stringify(this.respObject));
                    this.isCategory = true;
                    // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
                    this.baseCategories = this.messageService.copyArray(this.respObject.details.arr);
                    this.allTicketTypes = this.respObject.details.arr;
                    this.disabledCount = this.respObject.details.count;
                    // this.priorityType = this.respObject.details[0].val.type;
                    this.cat = [];
                } else {
                    //   this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }
    searchTicketWithFilter(query, isNewSearch) {
        if (isNewSearch === 1) {
            this.service.resetPaginationOptions();
            this.gridOptions2.pagination.totalItems = 0;
            this.nextOffset = 1;
            if (this.searchPageSizeBulk === 0) {
                query = '$top=' + defaultPageSize;
            } else {
                query = '$top=' + this.searchPageSizeBulk;
            }
        }
        const queryParams = query.toLowerCase().split('&');
        for (const param of queryParams) {
            //   console.log('param====' + JSON.stringify(param) + '==============' + param.includes('$skip='));
            if (param.includes('$top=')) {
                this.top = +(param.substring('$top='.length));
            }
            if (param.includes('$skip=')) {
                this.skip = +(param.substring('$skip='.length));
            } else {
                this.skip = 0;
            }
        }
        if (this.searchPageSizeBulk === 0) {
            this.searchPageSizeBulk = defaultPageSize;
        } else {
            this.searchPageSizeBulk = this.top;
        }
        this.nextOffset = this.skip;
        let ticketId;
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        if (tdate !== '') {
            this.toDate = tdate;
        } else {
            this.toDate = this.endDate;
        }
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        if (fdate !== '') {
            this.fromDate = fdate;
        } else {
            this.fromDate = this.startDate;
        }
        let isError = false;
        // let cats;
        // console.log('this.cat.length====' + JSON.stringify(this.cat));
        if (this.cat.length > 0) {
            this.categoryFilter = '';
        }

        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                // console.log('this.cat===' + JSON.stringify(this.cat[i]));
                this.categoryFilter += this.cat[i].pid + '#' + this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    this.categoryFilter += ',';
                }
            } else {
                isError = true;
                break;
            }
        }
        const lastChar = this.categoryFilter.substr(-1);
        if (lastChar === ',') {
            this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
        }

        if (this.categoryFilter === '') {
            this.categoryFilter = '0';
        }

        if (this.islead) {
            this.lead = 'Y';
        } else {
            this.lead = 'N';
        }

        if (this.ticket_id === '') {
            ticketId = 0;
        } else {
            ticketId = this.ticket_id;
        }

        if (this.raised !== '') {
            this.raisedTypeSelected = 1;
        } else {
            this.raisedTypeSelected = 0;
        }
        this.dataset = [];
        const data = {
            'ticketTypeId': this.ticketTypeId,
            'clientId': this.clientId,
            'supportgrp_id': this.userGroupSelected,
            'ticketStatusId': this.ticketStatusSelected,
            'ticket_id': this.ticketId,
            'busi_priority_id': this.prioritySelected,
            'created_frdate': this.fromDate,
            'created_todate': this.toDate,
            'catFilterLt': this.categoryFilter,
            'isTeamLead': "N",
            'raisedType': this.raisedTypeSelected,
            'raisedValue': this.raised,
            'assign_id': this.assigneeSelected,
            'grpLevel': 1,
            'isDashboardSearch': 1,
            'ticketTypeSeqNo': this.seq,
            'page_size': this.pageSize,
            'nextOffset': this.nextOffset,
            'paginationType': this.paginationObj,
            'isManagement': "false",
            'issearchbyspg': true,
            'bulkassginement': true
        };
        this._rest.AdvancesearchTicketForCit(data).subscribe((res) => {
            this.respObject = res;
            // console.log('checking data ==========', JSON.stringify(data));
            this.filterSearchLoaded = true;
            if (this.respObject.success) {
                this.gridObj2.getSelectionModel().setSelectedRanges([]);
                for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
                    this.respObject.details.dataObj[i].createdSince =
                        this.messageService.datePipeFunc(this.respObject.details.dataObj[i].createdSince);
                    this.respObject.details.dataObj[i].dDate =
                        this.messageService.datePipeFunc(this.respObject.details.dataObj[i].dDate);
                    this.respObject.details.dataObj[i].updateDate =
                        this.messageService.datePipeFunc(this.respObject.details.dataObj[i].updateDate);
                    if (this.respObject.details.dataObj[i].closureDate === undefined) {
                        this.respObject.details.dataObj[i].closureDate = '';
                    } else {
                        this.respObject.details.dataObj[i].closureDate =
                            this.messageService.datePipeFunc(this.respObject.details.dataObj[i].closureDate);
                    }
                    this.respObject.details.dataObj[i].requestedDate =
                        this.messageService.datePipeFunc(this.respObject.details.dataObj[i].requestedDate);
                }
                this.dataset = this.respObject.details.dataObj;
                // if (offset === 0) {
                //     this.totalData = this.respObject.details.totalData[0].count;
                //     this.totalPage = this.respObject.details.totalPage;
                //     if (this.totalPage === 0) {
                //         this.totalPage = 1;
                //     }
                //     console.log('checking totalPage', this.totalPage);

                // }

                if (this.nextOffset === 0) {
                    this.gridOptions2.pagination.totalItems = this.respObject.details.totalData[0].count;
                    this.totalItems = this.respObject.details.totalData[0].count;

                }
                this.gridOptions2 = Object.assign({}, this.gridOptions2);
                // console.log('For Grid Options ==========', JSON.stringify(this.gridOptions2));

            } else {
                alert(this.respObject.errorMessage);
            }
        });
    }

    getColumnDefintion() {
        this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.ticketTypeId).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                const data = this.respObject.details;
                // // console.log(JSON.stringify(data));
                this.columnDefinitions = [
                    { id: 'checkbox', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true },
                    {
                        id: 'ticket_id',
                        name: 'Ticket Id',
                        field: 'ticket_id',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'createdBy',
                        name: 'Created By',
                        field: 'createdBy',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'createdSince',
                        name: 'Created Since',
                        field: 'createdSince',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                        // ,type: FieldType.dateIso
                    },
                    {
                        id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 150, filterable: true
                    },
                    {
                        id: 'reqInfo',
                        name: 'RequesterInfo',
                        field: 'reqInfo',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'assignee',
                        name: 'Assignee',
                        field: 'assignee',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'LEVELSHORTDESC',
                        name: 'Group',
                        field: 'LEVELSHORTDESC',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'dDate',
                        name: 'Due Date',
                        field: 'dDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                        // type: FieldType.dateIso
                        // formatter: Formatters.dateTimeIso
                    },
                    {
                        id: 'closureDate',
                        name: 'Closure Date',
                        field: 'ticketCloseDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                        // ,type: FieldType.dateIso
                    },
                    {
                        id: 'escLevel',
                        name: 'Escalation Level',
                        field: 'escalated_to_grp_nm',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    this.columnDefinitions.push({
                        id: data[i].field,
                        name: data[i].name,
                        field: data[i].field,
                        minWidth: 100,
                        sortable: true,
                        filterable: false
                    });
                }
                this.columnDefinitions.push({
                    id: 'title',
                    name: 'Ticket Title',
                    field: 'tName',
                    minWidth: 100,
                    sortable: true,
                    filterable: false
                });
                this.columnDefinitions.push({
                    id: 'entity',
                    name: 'Entity',
                    field: 'entity_code',
                    minWidth: 100,
                    sortable: true,
                    filterable: false
                }, {
                    id: 'ic', name: 'IC', field: 'ic', minWidth: 100, sortable: true, filterable: true
                }, {
                    id: 'sbu', name: 'SBU', field: 'sbu', minWidth: 100, sortable: true, filterable: true
                }, {
                    id: 'loction',
                    name: 'LOCATION',
                    field: 'location',
                    minWidth: 100,
                    sortable: true,
                    filterable: true
                }, {
                    id: 'band', name: 'Band', field: 'band', minWidth: 100, sortable: true, filterable: false
                });
                if (this.grpLevel !== 0) {
                    this.columnDefinitions.push({
                        id: 'priority',
                        name: 'Priority',
                        field: 'priority',
                        minWidth: 100,
                        sortable: true,
                        filterable: false
                    });
                }
                const classes = document.getElementsByClassName('search-filter');
                for (let i = 0; i < classes.length; i++) {
                    classes[i].setAttribute('placeholder', '');
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    onSelectTicketType(selectedIndex) {
        this.ticketTypeId = this.types[selectedIndex].id;
        this.seq = this.types[selectedIndex].seq;
        this.getStatus(this.seq);
        this.getTicketLoadingDataWithAttr();
        this.setDisplayModal();
    }

    onCategoryChange(ticket, option) {

        // if(this.ticketTypes)

        const opt = JSON.parse(option);
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //   this.attachment = [];
            // }
            const value = opt.id;
            let matched = false;
            const index = this.allTicketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // console.log('index:' + index, this.disabledCount);
            // console.log(typeof this.disabledCount, typeof index);
            const index1 = this.allTicketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.allTicketTypes[index1].options[0].id;
            // // console.log(this.allTicketTypes[index1].options[0]);
            // console.log(index1);
            if (index1 === this.disabledCount) {
                // console.log('inside index'+this.cat.length);
                if (this.cat.length === 0) {
                    let pid1, cid1;
                    for (let i = 0; i < this.disabledCount; i++) {
                        pid1 = this.baseCategories[i].options[1].id;
                        cid1 = this.baseCategories[i].options[0].id;
                        this.cat.push({ pid: pid1, cid: cid1 });
                    }
                }

            }
            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value });
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // // console.log('matched');
                        // // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            // console.log(JSON.stringify(this.cat));
            // clear sub categories
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.allTicketTypes.length; i++) {
                    const options = this.allTicketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.allTicketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }

            this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
                this.respObject = res;
                // console.log('+++++++++++++++++++++++++++' + JSON.stringify(this.ticketTypes));
                let data;
                if (index > -1) {
                    data = this.allTicketTypes[index].options[0];
                }
                if (this.respObject.success) {
                    // data = this.ticketTypes[index].options[0];
                    this.respObject.details.unshift(data);
                    this.allTicketTypes[index].options = this.respObject.details;
                    // console.log('+++++++++++++++++++++++++++' + JSON.stringify(this.ticketTypes[index].options));
                } else {
                    if (index > -1) {
                        this.allTicketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }





    // saveData() {



    //     for (let i = 0; i < this.selectedTitles2.length; i++) {
    //         if (this.Tickets.indexOf(this.selectedTitles2[i].id) === -1) {
    //             this.Tickets.push(this.selectedTitles2[i].id);
    //         }
    //     }
    //     let data = {
    //         "ticket_ids": this.selectedTitles2,
    //         "client_id": this.clientId,
    //         "support_group": this.userGroupSelected,
    //         "assignee_id": this.assigneeSelected,
    //         "created_id": this.messageService.getUserId()
    //     }
    //     this._rest.createBulkAssignmentTicket(data).subscribe((res) => {
    //         // console.log('Im here 5 ====>', this.data);
    //         this.respObject = res;
    //         this.dataLoaded = true;
    //         if (this.respObject.success) {
    //             // const msg = this.respObject.id;
    //             //   this.notifier.notify('success', "Bulk Assignment Initiated");
    //             // alert('Your Ticket id is:' + msg);
    //             console.log('createBulkAssignmentTicket ====>', this.assigneeSelected);
    //         } else {
    //             this.notifier.notify('error 1', this.respObject.errorMessage);
    //             // alert(this.respObject.errorMessage);
    //             // console.log('Im here 2 ====>', this.assigneeSelected);
    //         }
    //     }, (err) => {
    //         // this.notifier.notify('error 2', this.messageService.SERVER_ERROR);
    //         // console.log('Im here 3 ====>', this.assigneeSelected);
    //     });


    //     (error) => {
    //         console.error("API error:", error);
    //     }







    //     // console.log('assigneeSelected====>', this.assigneeSelected);
    //     // console.log(' this.selectedTitles2======>', this.selectedTitles2);


    // }

    saveData() {
           console.log('Im here saveData ====>');
            this.notifier.notify('success', 'Bulk Assignment Initiated');
        for (let i = 0; i < this.selectedTitles2.length; i++) {
            if (this.Tickets.indexOf(this.selectedTitles2[i].id) === -1) {
                this.Tickets.push(this.selectedTitles2[i].id);
            }
        }

        let data = {
            "ticket_ids": this.selectedTitles2,
            "client_id": this.clientId,
            "support_group": this.userGroupSelected,
            "assignee_id": this.assigneeSelected,
            "created_id": this.messageService.getUserId()
        }
      console.log('Im here saveData3 ====>', JSON.stringify(data));
        this._rest.createBulkAssignmentTicket(data).subscribe((res) => {
           console.log('Im here 5 ====>', JSON.stringify(res));
            this.respObject = res;
            this.dataLoaded = true;
            if (this.respObject.success) {
                // const msg = this.respObject.id;
                // this.notifier.notify('success', 'Bulk Assignment Initiated');
           //    alert('Your Ticket id is:');
                console.log('success ====>');
            } else {
                // this.notifier.notify('error 1', this.respObject.errorMessage);
                // alert(this.respObject.errorMessage);
             console.log('Im here 2 ====>', this.assigneeSelected);
            }
        }, (err) => {
            // this.notifier.notify('error 2', this.messageService.SERVER_ERROR);
           console.log('Im here 3 ====>');
        });

    }

    handleSelectedRowsChanged(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj.getDataItem(idx);
                return item || '';
            });
            if (this.selectedTitles.length > 0) {
                this.show = true;
                this.selected = this.selectedTitles.length;
            } else {
                this.show = false;
            }
            // console.log(JSON.stringify(this.selectedTitles));
        }
    }

    handleSelectedRowsChanged2(e, args) {
        // console.log(args);
        // console.log('====e', e);
        if (Array.isArray(args.rows)) {
            this.selectedTitles2 = args.rows.map(idx => {
                const item = this.gridObj2.getDataItem(idx);
                return item || '';
            });
        }
        //   const selectedRow = this.angularGrid2.gridService.getColumnFromEventArguments(args);
        //   const data = selectedRow.dataContext;
        //   console.log("checking id",data);
        //   this.Tickets.push(data.id)
        //   console.log('Tickerts', this.Tickets);
    }
    ticketSearch() {
        // if (this.fromDate !== '' || this.toDate !== '') {
        //     this.advanceSearch({ 'offset': 0, 'paginationType': '' });
        // }
        this.advanceSearch({ 'offset': 0, 'paginationType': '' });
    }

    advanceSearch(paginationObj) {
        if (paginationObj === 1) {
            this.service.resetPaginationOptions();
            this.gridOptions2.pagination.totalItems = 0;
            this.nextOffset = 1;
            if (this.searchPageSizeBulk === 0) {
                this.query = '$top=' + defaultPageSize;
            } else {
                this.query = '$top=' + this.searchPageSizeBulk;
            }
        }

        // console.log("Total Items ==== > ", this.totalItems);

        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        // console.log('offset====' + offset);
        if (offset === 0) {
            this.totalData = 0;
            this.totalPage = 0;
            this.page_no = 0;
        }
        // console.log('offset====' + this.totalPage);
        // console.log('offset==== page_no' + this.page_no);
        // this.nextOffset = this.skip;
        // console.log('nextOffset====' + this.nextOffset);
        // ==============================================================
        let ticketId;
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        if (tdate !== '') {
            this.toDate = tdate;
        } else {
            this.toDate = this.endDate;
        }
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        if (fdate !== '') {
            this.fromDate = fdate;
        } else {
            this.fromDate = this.startDate;
        }
        let isError = false;
        // let cats;
        // console.log('this.cat.length====' + JSON.stringify(this.cat));
        if (this.cat.length > 0) {
            this.categoryFilter = '';
        }

        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                // console.log('this.cat===' + JSON.stringify(this.cat[i]));
                this.categoryFilter += this.cat[i].pid + '#' + this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    this.categoryFilter += ',';
                }
            } else {
                isError = true;
                break;
            }
        }
        const lastChar = this.categoryFilter.substr(-1);
        if (lastChar === ',') {
            this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
        }


        if (this.categoryFilter === '') {
            this.categoryFilter = '0';
        }

        if (this.islead) {
            this.lead = 'Y';
        } else {
            this.lead = 'N';
        }

        if (this.ticket_id === '') {
            ticketId = 0;
        } else {
            ticketId = this.ticket_id;
        }

        if (this.raised !== '') {
            this.raisedTypeSelected = 1;
        } else {
            this.raisedTypeSelected = 0;
        }
        // const lastChar = this.categoryFilter.substr(-1);
        // if (lastChar === ',') {
        //     this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
        // }


        // if (this.categoryFilter === '') {
        //     this.categoryFilter = '0';
        // }

        // if (this.islead) {
        //     this.lead = 'Y';
        // } else {
        //     this.lead = 'N';
        // }

        // if (this.ticket_id === '') {
        //     ticketId = 0;
        // } else {
        //     ticketId = this.ticket_id;
        // }

        // if (this.raised !== '') {
        //     this.raisedTypeSelected = 1;
        // } else {
        //     this.raisedTypeSelected = 0;
        // }
        this.dataset = [];
        const data = {
            'ticketTypeId': this.ticketTypeId,
            'clientId': this.clientId,
            'supportgrp_id': this.userGroupSelected,
            'ticketStatusId': this.ticketStatusSelected,
            'ticket_id': ticketId,
            'busi_priority_id': this.prioritySelected,
            'created_frdate': this.fromDate,
            'created_todate': this.toDate,
            'catFilterLt': this.categoryFilter,
            'isTeamLead': "N",
            'raisedType': this.raisedTypeSelected,
            'raisedValue': this.raised,
            'assign_id': this.assigneeSelected,
            'grpLevel': 1,
            'isDashboardSearch': 1,
            'ticketTypeSeqNo': this.seq,
            'page_size': this.pageSize,
            'nextOffset': offset,
            'paginationType': this.paginationObj,
            'isManagement': "false",
            'issearchbyspg': true,
            'bulkassginement': true
        };


        if (ticketId.length < 6) {
            this.notifier.notify('error', 'Please enter last 6 digits of ticket id');
        } else if (this.raised !== '' && this.raisedTypeSelected === 0) {
            this.notifier.notify('error', 'Please select raised type');
        } else {
            this.ticketIdSearchLoaded = false;
            // console.log('this.grpLevel=' + this.grpLevel + ' ticketId.length=' + ticketId.length);
            if (this.grpLevel > 0 && (ticketId.length >= 6 || this.raised !== '')) {
                this._rest.searchTicketById(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.ticketIdSearchLoaded = true;
                        if (this.respObject.details.dataObj.length > 0) {
                            this.displayTicket(res, offset, paginationType);
                        } else {
                            this.notifier.notify('success', this.messageService.BLANK_RESULT);
                            this.dataset = [];
                        }
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                });
            } else {
                this._rest.AdvancesearchTicket(data).subscribe((res) => {
                    this.respObject = res;
                    // console.log('checking data 123==========', JSON.stringify(data));
                    if (this.respObject.success) {
                        this.ticketIdSearchLoaded = true;
                        if (this.respObject.details.dataObj.length > 0) {
                            this.displayTicket(res, offset, paginationType);
                            this.gridOptions2.pagination.totalItems = this.respObject.details.totalData[0].count;
                            this.totalItems = this.respObject.details.totalData[0].count;
                        } else {
                            this.notifier.notify('success', this.messageService.BLANK_RESULT);
                            this.dataset = [];
                        }
                        // resolve(this.respObject);
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                    // this.filterSearchLoaded = true;
                    // if (this.respObject.success) {
                    //     this.gridObj2.getSelectionModel().setSelectedRanges([]);
                    //     for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
                    //         this.respObject.details.dataObj[i].createdSince =
                    //             this.messageService.datePipeFunc(this.respObject.details.dataObj[i].createdSince);
                    //         this.respObject.details.dataObj[i].dDate =
                    //             this.messageService.datePipeFunc(this.respObject.details.dataObj[i].dDate);
                    //         this.respObject.details.dataObj[i].updateDate =
                    //             this.messageService.datePipeFunc(this.respObject.details.dataObj[i].updateDate);
                    //         if (this.respObject.details.dataObj[i].closureDate === undefined) {
                    //             this.respObject.details.dataObj[i].closureDate = '';
                    //         } else {
                    //             this.respObject.details.dataObj[i].closureDate =
                    //                 this.messageService.datePipeFunc(this.respObject.details.dataObj[i].closureDate);
                    //         }
                    //         this.respObject.details.dataObj[i].requestedDate =
                    //             this.messageService.datePipeFunc(this.respObject.details.dataObj[i].requestedDate);
                    //     }
                    //     this.dataset = this.respObject.details.dataObj;

                    //     if (offset === 0) {
                    //         this.totalData = this.respObject.details.totalData[0].count;
                    //         this.totalPage = this.respObject.details.totalPage;
                    //         if (this.totalPage === 0) {
                    //             this.totalPage = 1;
                    //         }
                    //         console.log('checking totalPage', this.totalPage);

                    //     }
                    //     if (this.respObject.details.dataObj.length > 0) {
                    //         this.dataset = this.respObject.details.dataObj;
                    //         this.nextOffset = this.respObject.details.nextOffset;
                    //         this.offset = this.respObject.details.nextOffset;
                    //         this.previousOffset = this.respObject.details.previousOffset;
                    //         if (paginationType === 'next') {
                    //             this.page_no = this.page_no + 1;
                    //         } else if (paginationType === 'prev') {
                    //             this.page_no = this.page_no - 1;
                    //         } else if (paginationType === '' && this.page_no === 0) {
                    //             this.page_no = this.page_no + 1;
                    //         }
                    //         if (this.totalData <= this.pageSize * this.page_no) {
                    //             this.nextOffset = 0;
                    //         }

                    //         if (this.page_no === 1) {
                    //             this.previousOffset = 0;
                    //         }
                    //         console.log('checking page no', this.page_no);

                    //     } else if (this.respObject.details.dataObj.length === 0 && paginationType === 'next') {
                    //         this.nextOffset = 0;
                    //     } else if (paginationType === '' && this.page_no === 0) {
                    //         this.page_no = this.page_no + 1;
                    //     }

                    //     if (this.nextOffset === 0) {
                    //         this.gridOptions2.pagination.totalItems = this.respObject.details.totalData[0].count;
                    //         this.totalItems = this.respObject.details.totalData[0].count;
                    //     }

                    //     this.gridOptions2 = Object.assign({}, this.gridOptions2);


                    // } else {
                    //     alert(this.respObject.errorMessage);
                    // }
                });

            }
        }




        // if (ticketId.length < 4) {
        //     this.notifier.notify('error', 'Please enter last 4 digits of ticket id');
        // } else if (this.raised !== '' && this.raisedTypeSelected === 0) {
        //     this.notifier.notify('error', 'Please select raised type');
        // } else {
        //     this.ticketIdSearchLoaded = false;
        //     console.log('this.grpLevel=' + this.grpLevel + ' ticketId.length=' + ticketId.length);
        //     if (this.grpLevel > 0 && (ticketId.length >= 4 || this.raised !== '')) {
        //         this._rest.searchTicketById(data).subscribe((res) => {
        //             this.respObject = res;
        //             if (this.respObject.success) {
        //                 this.ticketIdSearchLoaded = true;
        //                 if (this.respObject.details.dataObj.length > 0) {
        //                     this.displayTicket(res, offset, paginationType);
        //                 } else {
        //                     this.notifier.notify('success', this.messageService.BLANK_RESULT);
        //                     this.dataset = [];
        //                 }
        //             } else {
        //                 this.notifier.notify('error', this.respObject.errorMessage);
        //             }
        //         });
        //     } else {
        //         this._rest.AdvancesearchTicket(data).subscribe((res) => {
        //             this.respObject = res;
        //             console.log('loader Bulk=====', this.respObject.success);
        //             console.log('checking data ==========', JSON.stringify(data));
        //             if (this.respObject.success) {
        //                 this.ticketIdSearchLoaded = true;
        //                 if (this.respObject.details.dataObj.length > 0) {
        //                     this.displayTicket(res, offset, paginationType);
        //                 } else {
        //                     this.notifier.notify('success', this.messageService.BLANK_RESULT);
        //                     this.dataset = [];
        //                 }
        //                 resolve(this.respObject);
        //             } else {
        //                 this.notifier.notify('error', this.respObject.errorMessage);
        //             }
        //         });
        //     }
        // }
    }

    getNextData() {
        this.advanceSearch({ 'offset': this.nextOffset, 'paginationType': 'next' });
    }

    getPreviousData() {
        this.advanceSearch({ 'offset': this.previousOffset, 'paginationType': 'prev' });
    }

    onPageSizeChange(value: any) {
        this.pageSize = this.pageSizeObj[value].value;
        this.advanceSearch({ 'offset': 0, 'paginationType': '' });
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketTypeSubscription) {
            this.ticketTypeSubscription.unsubscribe();
        }

        // if (this.closeModalSubscribe) {
        //     this.closeModalSubscribe.unsubscribe();
        // }
        //
        // if (this.commentSubscribe) {
        //     this.commentSubscribe.unsubscribe();
        // }
    }

    onCellChanged(e, args) {
        // console.log(args.item);
    }


    onCellClicked(e, args) {
        // const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
        // const data = selectedRow.dataContext;
        // this.messageService.setModalData(data);
        // this.setDisplayModal();
    }

    nullCheck(value) {
        if (value === null || value === 'null') {
            return 'N/A';
        } else {
            return value;
        }
    }

    valueNullCheck(data) {
        const psObj = {};
        for (const k in data) {
            psObj[k] = this.nullCheck(data[k]);
        }
        // this.psInfo.push(psObj);
        return psObj;
    }

    changeRouting() {
        // this.messageService.changeRouting(path);
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
    }

}
